import { ICSSProperties } from './ICSSProperties';

export interface IFont {
	family: string;
	size: string;
	color: string;
	bold: boolean;
	italic: boolean;
	underline: boolean;
	strikethrough: boolean;
}

export const CovertFontToCSS = function (font: IFont, defaultValues?: IFont): ICSSProperties {
	font = { ...defaultValues, ...font };

	let textDecoration = '';

	if (font.underline) {
		textDecoration = 'underline';
	}

	if (font.strikethrough) {
		textDecoration += ' line-through';
	}

	return {
		fontFamily: font.family,
		fontSize: font.size + 'px',
		color: font.color,
		fontWeight: font.bold ? 'bold' : 'normal',
		fontStyle: font.italic ? 'italic' : 'normal',
		textDecoration: textDecoration || 'none'
	};
};
